<template>
  <div class="confirmation-page">
    <mobile-header :show-back="false" :title="$t('FoodB_0526_CJIS_cGuT')" />
    <div class="confirmation-container">
      <h1 class="title">{{ $t('FoodB_0526_CJIS_cGuT') }}</h1>

      <progress-steps
        :steps="[
          $t('FoodB_0526_obJO_XULq', { number1: 1 }), // FoodB_0526_obJO_XULq 步骤{{number1}}
          $t('FoodB_0526_BiXD_Hdyk', { number2: 2 }), // FoodB_0526_BiXD_Hdyk 步骤{{number2}}
        ]"
        :current-step="1"
      />

      <div class="illustration">
        <img src="@/assets/images/delivery-rider.png" alt="Delivery Rider" />
      </div>

      <div class="content">
        <p class="main-text">{{ $t('FoodB_0526_WpAq_pLIl') }}</p>
        <p class="sub-text">{{ $t('FoodB_0526_HUpD_BgTa') }}</p>
      </div>

      <go-button class="confirm-button" @click="handleConfirm">
        {{ $t('FoodB_0526_Ugoi_wHIL') }}
      </go-button>
    </div>
  </div>
</template>

<script>
import ProgressSteps from '@/components/progress-steps'
import Track from '@/utils/track'
import MobileHeader from '@/components/mobile-header'

export default {
  name: 'ConfirmationEntrega',
  components: {
    ProgressSteps,
    MobileHeader,
  },
  data() {
    return {}
  },
  mounted() {
    Track.deliveringShow()
  },
  methods: {
    async handleConfirm() {
      try {
        Track.deliveryArrivedClick()
        // 跳转到验证页面
        this.$router.push({
          path: '/confirmation-entrega/locator',
        })
      } catch (error) {
        console.error('Error:', error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.confirmation-page {
  background-color: #fff;

  .confirmation-container {
    max-width: 750px;
    margin: 0 auto;
    text-align: center;
    padding: 40px;

    .title {
      font-size: 48px;
      font-weight: bold;
      margin-bottom: 60px;
      color: #333;
    }

    .illustration {
      margin: 60px 0;

      img {
        width: 280px;
        height: auto;
      }
    }

    .content {
      margin: 60px 0;

      .main-text {
        font-family: DiDiSans-Pro-Bold;
        font-size: 48px;
        color: #0b0b0d;
        letter-spacing: 0;
        text-align: center;
        line-height: 56px;
        font-weight: 700;
      }

      .sub-text {
        margin-top: 32px;
        font-family: DiDiSans-Pro-Regular;
        font-size: 32px;
        color: #0b0b0d;
        letter-spacing: 0;
        text-align: center;
        line-height: 38px;
        font-weight: 400;
      }
    }

    .confirm-button {
      margin-top: 60px;
      width: 100%;
    }
  }
}
</style>
